module.exports = __webpack_public_path__ + "static/media/iconAddWallet.1befb5ac.svg";